import type { AiHelpContext } from '@buyerflo/core/schemas/aiHelp'
import { useUserData } from 'auth'
import posthog from 'lib/posthog'
import { useCallback } from 'react'
import { useMatch } from 'react-router'

export function useAiHelpContext(): () => AiHelpContext {
    const { user } = useUserData()
    const matchParams = useMatch('/:orgId/:currentPage/*')?.params

    return useCallback(() => {
        // Scan DOM for visible data-help-id elements
        const helpElements = document.querySelectorAll('[data-help-id]')
        const visibleHelpIds: string[] = []
        helpElements.forEach(el => {
            const rect = el.getBoundingClientRect()
            if (rect.width > 0 && rect.height > 0) {
                const id = el.getAttribute('data-help-id')
                if (id) visibleHelpIds.push(id)
            }
        })

        return {
            currentRoute: `/${matchParams?.currentPage ?? ''}`,
            visibleHelpIds,
            userPermissions: user.permissions ?? [],
            sessionId: posthog.get_session_id?.() ?? undefined,
        }
    }, [matchParams?.currentPage, user.permissions])
}
